import { render, staticRenderFns } from "./OtherInfo.vue?vue&type=template&id=9c2eafa8&scoped=true"
import script from "./OtherInfo.vue?vue&type=script&lang=js"
export * from "./OtherInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2eafa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c2eafa8')) {
      api.createRecord('9c2eafa8', component.options)
    } else {
      api.reload('9c2eafa8', component.options)
    }
    module.hot.accept("./OtherInfo.vue?vue&type=template&id=9c2eafa8&scoped=true", function () {
      api.rerender('9c2eafa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/storeDetails/components/OtherInfo.vue"
export default component.exports